import { cn } from '../../lib/format.js';
import { Button } from './Button.jsx';

/**
 * Every list in the store has one of these. PRD §8: empty states invite an
 * action rather than apologise, so the copy passed in should say what to do
 * next, not that something is missing.
 */
export const EmptyState = ({ title, description, action, secondaryAction, icon, className }) => (
  <div className={cn('flex flex-col items-center px-6 py-16 text-center', className)}>
    {icon && <div className="mb-5 text-muted/50">{icon}</div>}
    <h3 className="font-display text-lg tracking-[-0.02em] text-ink">{title}</h3>
    {description && <p className="mt-2 max-w-sm text-xs leading-relaxed text-muted">{description}</p>}
    {(action || secondaryAction) && (
      <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
        {action && (
          <Button to={action.to} onClick={action.onClick} variant="primary" size="md">
            {action.label}
          </Button>
        )}
        {secondaryAction && (
          <Button to={secondaryAction.to} onClick={secondaryAction.onClick} variant="outline" size="md">
            {secondaryAction.label}
          </Button>
        )}
      </div>
    )}
  </div>
);

export default EmptyState;
